<template>
  <div id="app">
      <div class="body_bg">
        <div class="container pd15 whitebg">
          <el-row :gutter="25">
             <Mlogin/>
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" class="leftfloat">
              <div class="grid-content bg-purple-light">
                <div class="qkjj" v-if="recomList.length>0">
                    <el-carousel :interval="5000" trigger="click" arrow="always" class="hidden-sm-and-down qkjjbanner">
                      <el-carousel-item class="bananer" v-for="(item,index) in recomList" :key="index">
                        <div class="el-carousel__item item_banner" style="margin-top:-28px">
                           <el-row :gutter="5" v-for="(cont,i) in item" :key="i" >
                             <div class="item_pic" @click="godigese(cont.ArticleID)">
                                <img src="../assets/images/default.png" alt="" srcset="" v-if="cont.Picture==null" style="cursor: pointer;">
                            <img :src="Url+cont.Picture" v-else style="cursor: pointer;"> 
                             </div>
                            <div class="text">
                              <a class="title" v-html="cont.Title" @click="godigese(cont.ArticleID)"></a>
                              <p class="author" v-html="cont.AuthorsList"></p>
                              <div class="contentText" style="-webkit-box-orient: vertical;" v-html="cont.Abstract_Chinese"></div>
                            <div class="content">
                              <span @click="goExport(cont.ArticleID)"><i class="icon1"></i>导出</span>
                              <span @click="pdf(index,cont.PDFFile_Size,cont.ArticleID)" v-if="cont.PDFFile_Size>0"><i class="icon2"></i>PDF下载(<span style="color:red;margin-right:0px !important">{{cont.Read_Times}}</span>)</span>
                              <span @click="goHtml(cont.HtmlFileUrl)" v-if="cont.HtmlFileUrl"><i class="list_img browse"></i>
                                [HTML]</span>
                              
                              <span @click="oniscode(cont.HtmlFileUrl)" v-if="cont.HtmlFileUrl" title="扫码阅读HTML全文"><i class="icon3"></i>扫码</span>
                            </div>
                            </div>
                           </el-row>
                        </div>
                      </el-carousel-item>
                    </el-carousel>
                     <el-dialog
                              :visible.sync="centerDialogVisible"  width="30%" center>
                               <p>扫码阅读HTML全文</p>
                              <vue-qr :text="codeId" :size="150" class="Qrcode"></vue-qr>
                     </el-dialog>
                </div>
                <div class="dqml fifth">
                  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                    <el-tab-pane label="最新一期" name="first" class="buttona">
                      <IssueArticleListControl  :type="type" v-if="isyuchuban==false"  :List="List" :isdataa="true" :newListTitle="newListTitle" :Periods="Periods" :id="1" :scroll="true" :CloumnList="CloumnList"></IssueArticleListControl>
                    </el-tab-pane>
                    <el-tab-pane label="预出版" class="buttona" name="second" v-if="isycb">
                      <IssueArticleListControl  :type="type" v-if="isyuchuban" :isycb="isycb" :List="newList" :Periods="Periods" :id="1" :scroll="true"></IssueArticleListControl>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </el-col>
			<DocumentsNewsBlockControl></DocumentsNewsBlockControl>
          </el-row>
        </div>
      </div>
  </div>
</template>
<script>
  import FixedBlockControl from '../components/Home/FixedBlockControl'
  import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
  import xiazai from '@/assets/js/xiazai'
  import vueQr from 'vue-qr'
  export default {
    data() {
      return {
        keywords:'',
        activeName: 'first',
        data:{},
        newList:[],
        List:[],
        Lista:[],
        isyuchuban:false,
        cotype:"",
        Periods: {},
        FileGUID:"",
        type:0,
        SetItem:{},
        isycb:false,
        isycba:false,
        isLoginDown:false,
        isEBt:false,
        newListTitle:"",
        recomList:[],
        recomLista:[],
        recomListb:[],
        recomListc:[],
        codeId:0,
        centerDialogVisible: false,
        CloumnList:[],
      }
    },
    components: {
      FixedBlockControl,
      IssueArticleListControl,
      vueQr
    },
    created(){
      this.getArticList();
      this.GetIssue();
      this.getSet();      //获取系统配置
      this.GetRecomList(); //推荐列表
    },
    mounted(){
      if(this.$route.query.code){
        this.$store.dispatch("_getWeiXinLogin", {Scene: this.$route.query.code}).then(res=>{
             localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
             this.$store.dispatch("_GetRouter").then((res) => {
          localStorage.setItem("route", JSON.stringify(res.data.Data));
        });
       })
      }
       
    },
    methods: {
      getSet() {
          let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,2900,4553]
          //1000:期刊名称
          //1001：期刊英文名称
          //4530：（否）隐藏/（是）显示预出版模块
          //6018:预出版模块显示 （否）文章列表/（是）预出版内容
          //6019：是否需要登录下载文件
          //230：显示/隐藏所有的评论功能
          //6055：显示/隐藏列表和详情页的英文标题，英文关键字，英文摘要
          //5000： ISSN编号
          //5010：CN编号
          //11:是否启用手机短信
          //2900:是否启用英文网刊
          this.$store.dispatch("_getSet",params)
        .then(res => {
          this.SetItem=res.data.Data
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          this.SetItem.map((item)=>{
               if(item.SetItemID==4530){
               item.Item_Value=="是"?this.isycb=true:this.isycb=false
                }
                if(item.SetItemID==6018){
                  if (item.Item_Value=="是") {
                      this._getLista();
                    } else {
                      this._getListb();
                    }
                }
                if(item.SetItemID==6019){
               item.Item_Value=="是"?this.isLoginDown=true:this.isLoginDown=false
                }
              //   if(item.SetItemID==6055){
              //  item.Item_Value="是"?this.isEBt=true:this.isEBt=false
              //   }
          })
        }).catch(err => {
          console.log(err)
        })			
		
      },
        godigese(ids){
          this.$newOpen('/#/digest?ArticleID='+ids)
        },
      
      oniscode(num){
        this.centerDialogVisible=true
       this.codeId=num
      },
      handleClick(tab, event) {
        if(tab.index=="1"){
          this.type=1
          this.isyuchuban=true
          this.newList=this.Lista
        }
        if(tab.index=="0"){
            this.type=0
             this.isyuchuban=false
             this.newList=this.List
        }
      },
      getArticList() {
      let params = {
        PageSize: 0,
        IssueId: 0
      };
      this.$store
        .dispatch("_getNewlist", params)
        .then(res => {
          this.List = res.data.Data;
          this.Listb = res.data.Data;
          this.List.map(item=>{
            if(item.Column){
              this.CloumnList.push(item)
            }
          })
        })
        .catch(err => {
          console.log(err);
        });
    },
    goExport(ids){
      this.$newOpen('/#/Export?ids='+ids)
    },
      GetIssue() {
      this.$store
        .dispatch("_getYear", { Id: -1})
        .then(res => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle;
          let data={
            newYears:res.data.Data.Publish_Date,
            Volume:res.data.Data.Volume,
            CoverGUID:res.data.Data.CoverGUID,
            CoverSuffix:res.data.Data.CoverSuffix,
            YearIssue_NoTtitle:res.data.Data.YearIssue_NoTtitle
          }
          
          sessionStorage.setItem("newYears",JSON.stringify(data))
          this.Periods = res.data.Data;
          // if (res.data.Data.CoverGUID) {
          //   this.CoverGUID = true;
          // }
          // if (res.data.Data.BackCoverGUID) {
          //   this.BackCoverGUID = true;
          // }
          // if (res.data.Data.CoverGUID) {
          //   this.TableConGUID = true;
          // }
          // if (res.data.Data.RSS) {
          //   this.Rss = true;
          // }
        })
        .catch(err => {
          console.log(err);
        });
    },
    
	GetRecomList(){
			var time =new Date().getTime()
			let data = {
			  "PageSize":4,
        "Type":'Sort',
        "Key":"Recommended",
        "PageIndex":1
			}
			this.$store.dispatch("_getListb",data).then(res=>{
        if(res.data.IsSuccess){
          this.recomListc=res.data.Data
          for(let i=0;i<this.recomListc.length;i++){
            if(i<2){
              this.recomLista.push(this.recomListc[i])
            }else{
              this.recomListb.push(this.recomListc[i])
            }
          }
          this.recomList.push(this.recomLista)
          this.recomList.push(this.recomListb)
        }
        
      }).catch(err=>{
        console.log(err)
      })
		},
     pdf(i, size, guid) {
      if (size <= 0) {
        alert("文件不存在");
        return;
      }
      this.$store.dispatch("_getPDF", { Id: guid }).then(Result => {
        if (Result.data.IsSuccess) {
          this.$Download.DownloadBase64File(
            Result.data.Data.File,
            Result.data.Data.FileName
          );
        } else {
          alert(Result.data.Message);
        }
      });
    },
    goHtml(url){
      window.open(url, "_blank");
    },
    _getLista() {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getLista", {
          PageSize: 0,
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    _getListb() {
      var time = new Date().getTime();
      this.$store
        .dispatch("_getListb", {
          PageSize: 0,
          Type: "Sort",
          Key: "Preprint",
          src: time
        })
        .then(res => {
          if (res.data.IsSuccess) {
            this.Lista = res.data.Data;
          }
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
        
    }
  }
</script>

<style>
a{
  color: #222222;
}
.qkjj .el-carousel{
  background: #fff;
}

.qkjj .el-carousel__item{
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.item_banner .el-row{
    border: 1px #f1f1f1 solid;
    width: 48%;
    text-align: center;
    padding: 10px 12px;
    min-height: 284px;
    -webkit-box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
  -moz-box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
  box-shadow:rgba(0,0,0,0.09) 0px 6px 9px 0px;
}
.qkjj .el-carousel__indicators--horizontal{
  bottom: 20px;
}
.content span{
  margin-right: 15px;
  height: 21px;
  line-height: 21px;
  display: inline-flex;
}
.text{
 text-align: left;
}
.text .title{
  color: #00777b;
  font-size: 16px;
  font-weight: 600;
      width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}
.qkjj .el-carousel--horizontal{
  overflow: hidden;
}

.text .author{
line-height: 1.5;
margin-bottom: 5px;
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}
.text .contentText{
  color: #6f6f6f;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 1.5;
    margin-bottom: 5px;
    height: 40px;
}
.content span{
  cursor: pointer;
}
.content span i{
display: inline-block; 
width:19px;
height:19px; 
background:url("../assets/images/colum_arrow.png") no-repeat;
}
.content span  .icon1{
  background-position: 0px 2px
}
.content span  .icon2{
  background-position: 0px -17px
}
.content span  .icon3{
  background-position: 0px -36px
}
.el-tabs--card>.el-tabs__header .el-tabs__item{
  border-bottom: none;
}
.dqml .el-tabs__nav-scroll{
  border-bottom: 1px #00777b solid;
}
.dqml .el-tabs__nav-scroll .el-tabs__item{
  border-bottom: none !important;
}
.el-carousel__indicator.is-active button{
  /* background: #00777b !important; */
  background: #fff !important;
}

</style>
